/*
 * @描述:
 * @作者: lidong
 * @时间: Do not edit
 * @最后更新时间: Do not edit
 * @更新: lidong
 * @参考:
 */

import React from 'react';
import { Modal, Icon } from 'antd';
const delStyle = {
  left: '95%',
  position: 'absolute',
  top: '10px',
};

const ConfirmDel = props => {
  const modal = Modal.confirm({
    ...props,
    content: (
      <div>
        <Icon
          style={delStyle}
          type="close"
          onClick={() => {
            modal.destroy();
            props.handleDestroy && props.handleDestroy();
          }}
        />
        {props.content}
      </div>
    ),
  });
  return modal;
};

export default ConfirmDel;
